import React, { useState } from "react";
import { Line, Pie, Chart } from "react-chartjs-2";
import { chartColors } from "../../components/form/debtPayOff/components/color";
import "./mainDashboard.css";
import { Progress } from "antd";
import restIcon from "../../assets/images/budget/rest.svg";
import calanderIcon from "../../assets/images/budget/calander.png";
import { DatePicker } from "antd";
import { Select, Spin } from "antd";
import moment from "moment";
const { Option } = Select;

export const DashboardBudgetSection = (props) => {
  const [compareFilter, setCompareFilter] = useState("This Month");
  const [compareFilterNetWorth, setCompareFilterNetWorth] =
    useState("This Month");
  const { MonthPicker } = DatePicker;

  const totalAssets =
    props && props.monetary ? parseFloat(props.monetary).toFixed(2) : 0.0;

  const totalDebts =
    props.totalBalance || props.debt
      ? ((props.totalBalance || 0) + (props.debt || 0)).toFixed(2)
      : (props.totalBalance + props.debt).toFixed(2);

  const netWorth = (parseFloat(totalAssets) - parseFloat(totalDebts)).toFixed(
    2
  );

  function getRandomDarkColor() {
    const letters = "0123456789ABCDEF";
    let color = "#";
    for (let i = 0; i < 6; i++) {
      color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
  }
  const dataDonught = {
    labels: [
      `Total Assets: $${totalAssets
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`,
      `Total Debts: $${totalDebts
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`,
      `Net Worth: $${netWorth
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`,
    ],
    datasets: [
      {
        label: "# of Votes",
        data: [
          parseFloat(totalAssets),
          parseFloat(totalDebts),
          parseFloat(netWorth),
        ],
        backgroundColor: ["#09A84D", "#E53E3E", "#2A3DA3"],
        // borderColor:  [
        //     "rgb(255, 99, 132)",
        //     "rgb(54, 162, 235)",
        //     "rgb(255, 205, 86)",
        //   ],
        // borderWidth: 1,
      },
    ],
    // text: `${valueTotal && valueTotal}`,
  };

  const monthsFilter = [
    {
      id: 1,
      filter: "This Month",
    },
    {
      id: 2,
      filter: "Last Month",
    },
  ];
  const tags = [
    "Current Month",
    "This month to last month",
    "This year to last year",
    "This Month to last year",
  ];
  const filterData = (selectedFilter) => {
    let startDate, endDate;

    // Get current date
    const date = moment();

    switch (selectedFilter) {
      case "Current Month":
      case "This Month":
        startDate = date.startOf("month").format("YYYY-MM-DD"); // Start of the current month
        endDate = date.endOf("month").format("YYYY-MM-DD"); // End of the current month
        break;
      case "This month to last month":
        startDate = date
          .clone()
          .subtract(1, "month")
          .startOf("month")
          .format("YYYY-MM-DD"); // Start of last month
        endDate = date.endOf("month").format("YYYY-MM-DD"); // End of this month
        break;
      case "Last Month":
        startDate = date
          .clone()
          .subtract(1, "month")
          .startOf("month")
          .format("YYYY-MM-DD"); // Start of last month
        endDate = date
          .clone()
          .subtract(1, "month")
          .endOf("month")
          .format("YYYY-MM-DD"); // End of last month
        break;

      case "This year to last year":
        startDate = date
          .clone()
          .subtract(1, "year")
          .startOf("year")
          .format("YYYY-MM-DD"); // Start of last year
        endDate = date.endOf("year").format("YYYY-MM-DD"); // End of this year
        break;

      case "This Month to last year":
        startDate = date
          .clone()
          .subtract(1, "year")
          .startOf("month")
          .format("YYYY-MM-DD"); // Start of the same month last year
        endDate = date
          .clone()
          .subtract(1, "year")
          .endOf("month")
          .format("YYYY-MM-DD"); // End of the same month last year
        break;

      default:
        startDate = date.startOf("month").format("YYYY-MM-DD");
        endDate = date.endOf("month").format("YYYY-MM-DD");
    }

    // console.log("filterData", startDate, endDate);
    // props.getNetWorth(endDate);
  };
  return (
    <React.Fragment>
      {" "}
      <div
        className="budgetMaincards netWorthCard"
        style={{
          width: "100%",
          padding: "0px",
          borderRadius: "0px",
          position: "relative",
        }}
      >
        <div className="filterWithName">
          <h1 className="budgetCardheading">Net Worth</h1>
          <div className="compareSelectContainer">
            <div className="filterIcons">
              <Select
                suffixIcon={
                  <img
                    src={calanderIcon}
                    height={16}
                    width={17}
                    alt="icon"
                  ></img>
                }
                showSearch
                style={{ width: 170, outline: "none", border: "none" }}
                placeholder="Compare"
                onChange={(value, id) => {
                  console.log("value", value);
                  filterData(value);
                }}
              >
                {tags &&
                  tags.map((item, index) => (
                    <Option key={index} value={item}>
                      {item}
                    </Option>
                  ))}
              </Select>
            </div>
            <div className="compareSelect">
              {monthsFilter &&
                monthsFilter.map((item, index) => (
                  <div
                    key={index}
                    className={
                      item.filter === compareFilterNetWorth
                        ? "selectedfilter"
                        : "unSelectedfilter"
                    }
                    onClick={() => {
                      setCompareFilterNetWorth(item.filter);
                      filterData(item.filter);
                    }}
                  >
                    {item.filter}
                  </div>
                ))}
            </div>
            <img style={{ cursor: "pointer" }} src={restIcon} alt="reset" />
          </div>
        </div>
        <div className="netWorth">
          Net Worth:
          <span
            style={{ fontSize: "18px", fontWeight: "bold", color: "black" }}
          >
            {" "}
            ${" "}
            {netWorth &&
              netWorth.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
          </span>
        </div>
        <div style={{ marginTop: "1rem", display: "flex" }}>
          <Pie
            data={dataDonught}
            options={{
              // cutoutPercentage: 70,
              legend: {
                display: true,
                position: "right",
              },
            }}
          />
        </div>
        {props.loading ? (
          <div style={{ marginTop: "12px", display: "flex", justifyContent: "center", alignItems: "center", minHeight: "64px", borderRadius: "12px", border: "1px solid rgba(74, 98, 255, 0.35)", background: "linear-gradient(135deg, rgba(42, 61, 163, 0.16), rgba(42, 61, 163, 0.06))", boxShadow: "inset 0 1px 0 rgba(255,255,255,0.14)" }}>
            <Spin size="large" />
          </div>
        ) : null}
      </div>
    </React.Fragment>
  );
};
